import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceContext } from '../../../contexts/ServiceContext';
import ENDPOINT from '../../../globals/api-endpoint';
import NumberFormat from 'react-number-format';
import media from 'styled-media-query';
import { NavLink } from 'react-router-dom';
import flat2 from '../assets/flat2.png';
import { Helmet } from 'react-helmet';

const H3 = styled.h3`
	text-align: center;
	margin: 10px;
	padding: 10px;
`;

const ServiceListStyled = styled.div`
	margin-top: 20px;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 10px;
	${media.lessThan('small')`
		grid-gap: 20px;
		grid-template-columns: 1fr;
	`}
	${media.between('small', 'medium')`
		grid-gap: 20px;
		grid-template-columns: 1fr;
	`}
`;

const ServiceStyled = styled.div`
	display: grid;
	grid-gap: 5px;
	grid-template-columns: 1fr 3fr;
	border-radius: 5px;
	padding: 15px;
	transition: all 0.5s;
	&:hover {
		-webkit-box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
		-moz-box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
		box-shadow: 0px 1px 3px 0px rgba(140,140,140,1);
		cursor: pointer;
	}
	${props => {
		if(!props.ClosedStyled){
			return `border: 1px solid ${props.theme.green};`;
		} else {
			return `border: 1px solid red;`;
		}
	}}
	${media.lessThan('small')`
		grid-template-columns: 1fr;
	`}
`;

const H4 = styled.h4`
	margin-bottom: 5px;
	border-bottom: 1px solid gray;
	padding-bottom: 5px;
	color: black;
`;

const P = styled.p`
	font-size: 12px;
	margin-bottom: 5px;
	color: black;
`;

const Thumbnail = styled.div`
	background: white;
	width: 100%;
	height:100px;
`;

const Info = styled.div``;

const Filter = styled.div`
	display: inline-block;
`;

const Button = styled.button`
	margin: 0 5px 5px 0;
	max-width: 250px;
	border-radius : 5px;
	padding : 5px;
	color: white;
	font-family: 'Catamaran', sans-serif;
	background: ${props => props.theme.green};
	border: 2px solid ${props => props.theme.green};
	font-size: 14px;
	transition: all 0.5s;
	&:hover {
		cursor: pointer;
		color: ${props => props.theme.green};
		background: white;
	}
`;

const Img = styled.img`
	height: 100%;
	max-width : 100px;
	object-fit: cover;
  object-position: center;
`;

const Service = () => {
	const { services, dispatch } = useContext(ServiceContext);

	const [isLoading, setIsloading] = useState(null);
	const [isFailed, setIsFailed] = useState(null);
	const [categories, setCategories] = useState([]);

	const getCat = () => {
		fetch(ENDPOINT.GET_ALL_CAT)
		.then(res => res.json())
		.then(res => {
			setCategories(res.categories);
		})
		.catch(err => {
			console.log(err);
		})
	}

	useEffect(() => {
		getCat();
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsloading(true);
			fetch(ENDPOINT.ALL_SERVICES)
			.then(res => res.json())
			.then(res => {
				dispatch({type: 'GET_ALL_SERVICES', services: res.services});
				setIsFailed(false);
			})
			.catch(err => {
				console.log(err);
				setIsFailed(true);
			})
			.finally(res => {
				setIsloading(false)
			});
		}
		fetchData()
	}, [dispatch, services.length]);

	const loading = isLoading ? (
		<div className="loading">
			<div className="sk-folding-cube">
			  <div className="sk-cube1 sk-cube"></div>
			  <div className="sk-cube2 sk-cube"></div>
			  <div className="sk-cube4 sk-cube"></div>
			  <div className="sk-cube3 sk-cube"></div>
			</div>
		</div>
	) : (null);

	const failed = isFailed ? (
		<div className="failed">failed</div>
	) : (null);

	const ServiceList = services.map(service => {
		return(
			<NavLink to={'/layanan/' + service._id} key={service._id}><ServiceStyled>
				<Thumbnail>
					<Img src={flat2} alt={service.name}/>
				</Thumbnail>
				<Info>
					<H4>{service.name}</H4>
					<P><NumberFormat value={service.price} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} /></P>
					<P>{service.category.name}</P>
				</Info>
			</ServiceStyled></NavLink>
		);
	});

	const empty = services.length > 0 ? (null) : (<p>Belum ada layanan apapun</p>)

	const FilterView = categories.length > 0 ? (
		categories.map((cat) => {
			return(
				<NavLink key={cat._id} to={'/layanan-kategori/' + cat._id}>
					<Button>{cat.name}</Button>
				</NavLink>
			);
		})
	) : (null)

	return(
		<div className="services__container">
			<Helmet>
					<title>daftar layanan | bantuin</title>
				</Helmet>
			<H3>Daftar Layanan</H3>
			<Filter>
				{ FilterView }
			</Filter>
			{ loading }
			{ failed }
			<ServiceListStyled>
				{ isLoading ? (null) : (empty) }
				{ isLoading ? (null) : (ServiceList) }
			</ServiceListStyled>
		</div>
	);
}

export default Service;